import {Button, SxProps, Theme, Tooltip, useMediaQuery} from "@mui/material";
import {SteddiButtonLoader} from "./SteddiButtonLoader";

type props = {
  children: JSX.Element | string,
  icon?: JSX.Element,
  onClick: () => void,
  variant?: "contained" | "outlined" | "text"
  color?: "primary" | "secondary" | "contrast" | "error" | "success"
  onlyShowXs?: boolean
  noShrink?: boolean
  sx?: SxProps<Theme>
  fullWidth?: boolean,
  disabled?: boolean
  loading?: boolean
  tooltip?: string
}

export default function SteddiButton({children, onClick, icon, variant, color, onlyShowXs, noShrink, sx, fullWidth, disabled, loading, tooltip}: props) {
  // @ts-ignore
  const hidden = useMediaQuery(theme => theme.breakpoints.up('sm'));

  function handleClick() {
    if (!loading) onClick()
  }

  return (
    <Tooltip title={tooltip} placement="top">
      <div>
        <Button onClick={handleClick} disabled={disabled} variant={variant || "contained"} size="large" color={color || "primary"} fullWidth={fullWidth} endIcon={icon} disableElevation sx={[
          (theme) => ({
            [theme.breakpoints.down('md')]: {
              width: noShrink ? "auto" : "100%"
            },
            textTransform: "none",
            display: onlyShowXs && hidden ? "none" : "",
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}>{children}{loading && <SteddiButtonLoader/>}</Button>
      </div>
    </Tooltip>
  )
}